
export default class SubscribeComponent extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onSubmit = this.onSubmit.bind(this);
    this.onClickClear = this.onClickClear.bind(this);

    // selectors
    this._node = this;
    this._form = this._node.querySelector('form');
    this._email = this._form.querySelector('input[type="email"]');

    this._clear_icons = this._node.querySelectorAll('.clear-icon');
    this._clear_icons.forEach((el) => el.addEventListener('click', this.onClickClear));

    // event listeners
    this._form.addEventListener('submit', this.onSubmit);
    this._form.offsetHeight;

    KlaviyoSubscribe.attachToForms(`#${this._form.getAttribute('id')}`, {
      hide_form_on_success: false,
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      success: ($form, result) => {
        console.log('result:', result);
        setTimeout(() => {
          this._node.classList.add('full-send');

          if (result.is_subscribed === false) {
            this._node.classList.add('success');
          } else if (result.is_subscribed === true) {
            this._node.classList.add('exists');
          } else if (!result.is_subscribed) {
            this._node.classList.add('fail');
          }
        }, 1332);
      }
    });
  }

  /**
   * Handle submit.
   */
  onSubmit(e) {
    document.activeElement.blur();
    this._node.classList.add('sending');
  }

  /**
   * Click to clear form.
   */
  onClickClear() {
    this._email.value = '';
    this._node.classList.remove('sending', 'full-send', 'success', 'exists', 'overheated', 'fail');
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._form.removeEventListener('submit', this.onSubmit);
    this._clear_icons.forEach((el) => el.removeEventListener('click', this.onClickClear));
  }
}
